export default __webpack_public_path__ + "static/media/attendance_active.558ea50e.svg";